import { AppLayout } from '@practium/ui';
import { useAuth } from '@practium/features/auth';
import { useNavigation } from '@practium/features/navigation';
import { useNavigate } from 'react-router-dom';
import { useAdminNavbarConfig } from '../navbar/hooks/navbar.config';
import { useAdminSidebarConfig } from '../navigation/hooks/sidebar.config';

export const Layout = () => {
	const navigate = useNavigate();
	const { logout } = useAuth();

	const handleLogout = async () => {
		await logout();
		navigate('/login', { replace: true });
	};

	const navbarConfig = useAdminNavbarConfig();
	const sidebarConfig = useAdminSidebarConfig(handleLogout);

	const { isSidebarOpen, handleMenuClick, handleCloseSidebar, dynamicNavbarConfig } = useNavigation(
		{
			navbarConfig,
			customTitles: {
				'/analises': 'Análises',
				'/diario-de-campo': 'Diário de campo',
			},
		}
	);

	return (
		<AppLayout
			sidebarConfig={sidebarConfig}
			navbarConfig={dynamicNavbarConfig}
			isSidebarOpen={isSidebarOpen}
			onMenuClick={handleMenuClick}
			onCloseSidebar={handleCloseSidebar}
		/>
	);
};
